import api from "../api";

export type SubscriptionPayload = {
  email: string;
  name?: string;
  phone?: string;
};

export type SubscriptionResponse = {
  message?: string;
  subscription?: any;
  success: boolean;
};

const SubscriptionService = {
  async subscribe(data: SubscriptionPayload): Promise<SubscriptionResponse> {
    const res = await api.post("/subscriptions/subscribe", data);
    return res.data;
  },
};

export default SubscriptionService;
